// extracted by mini-css-extract-plugin
export default {"field":"EditableValueField_field__mjs+5","error":"EditableValueField_error__sGKlW","label":"EditableValueField_label__OpGfJ"};